import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import useModalStore from "../StatesStore/ModalStore";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
function ConfirmDelete() {
  const { title, data, closeModal } = useModalStore();
  const [loading, setLoading] = useState(false);
  console.log("data", data);
  console.log("title", title);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Modal show centered onHide={closeModal} className="confirmDelete">
      <style jsx>
        {`
          ${data?.componentName === "ShopListProdCard" &&
            `.confirmDelete .modal-content {
            margin: 0rem 13rem;
            box-shadow: 0 0.5rem 1rem rgba(83, 88, 93, 0.25) !important;
          }`}
        `}
      </style>

      <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
        <div className="d-flex flex-column">
          <div className="d-flex w-100 justify-content-between">
            <div className="h4">Delete {title || "Shopping List"}</div>
            <button
              type="button"
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "27px",
                height: "27px",
                background: "#FFFFFF",
                border: "1px solid #FF3B30",
                boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                borderRadius: "25px",
                flex: "none",
                order: "1",
                flexGrow: "0",
              }}
              onClick={closeModal}
            >
              <svg
                style={{ width: "11px" }}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#FF3B30"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <p>
            Are you sure you want to delete <strong>{data?.displayName}</strong>
            ? This action cannot be undone.
          </p>
        </div>
        <div className="d-flex flex-column gap-2 w-100">
          <Button
            className="rounded-3"
            variant="danger"
            onClick={async () => {
              if (data?.type === "cart") data?.deleteFunction(data?.id);
              else {
                try {
                  setLoading(true);
                  await data?.deleteFunction();
                } catch (error) {
                  console.log(error);
                } finally {
                  setLoading(false);
                }
              }
              closeModal();
              if (title === "Shopping List") {
                toast.success(
                  data?.displayName + " Deleted Successfully",
                  toastOptions
                );
              }
            }}
          >
            {loading ? (
              <div
                className="spinner-border text-white"
                style={{ width: "1rem", height: "1rem" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Delete"
            )}
          </Button>
          <Button
            className="rounded-3"
            variant="primary-soft"
            onClick={closeModal}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmDelete;
